import React from 'react';
import PropTypes from 'prop-types';
import tw, { styled } from 'twin.macro';

import { Flex, Label, TextArea, Button, Panel } from '@sopranodesign/pulse-components';
import Icon from '@sopranodesign/pulse-icons';

import AssistantMessageList from './AssistantMessageList';

const Container = styled(Panel)`
  ${tw`absolute z-20 flex`}
  box-sizing: border-box;
  bottom: 1rem;
  right: 1rem;
  width: 22rem;
  height: 32rem;
  flex-direction: column;
  padding: 0;
  overflow: hidden;
`;

const Header = styled.div`
  ${tw`flex items-center justify-between px-4 py-3 border-0 border-b border-solid border-gray-200`}
  flex-shrink: 0;
`;

const Footer = styled.div`
  ${tw`px-3 py-3 border-0 border-t border-solid border-gray-200`}
  flex-shrink: 0;
`;

const AssistantPanel = ({
  messages,
  prompt,
  loading,
  onPromptChange,
  onSubmit,
  onClose
}) => {
  const handleSubmit = event => {
    event.preventDefault();

    if (!prompt.trim() || loading) {
      return;
    }

    onSubmit(prompt);
  };

  const handleKeyDown = event => {
    if (event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault();
      handleSubmit(event);
    }
  };

  return (
    <Container>
      <Header>
        <Flex center xSpaceSm>
          <Icon type="sparkles" outline height="1rem" width="1rem" size="1rem" />
          <Label mb={false}>Workflow Assistant</Label>
        </Flex>
        <Button
          variant="inline"
          aria-label="Close assistant"
          onClick={onClose}>
          <Icon type="x" outline height="0.875rem" width="0.875rem" size="0.875rem" />
        </Button>
      </Header>

      <AssistantMessageList messages={messages} />

      <Footer>
        <Flex as="form" col ySpaceSm onSubmit={handleSubmit}>
          <TextArea
            value={prompt}
            onChange={onPromptChange}
            onKeyDown={handleKeyDown}
            placeholder="Ask the assistant… (Shift+Enter for newline)"
            rows={3}
            aria-label="Assistant prompt"
          />
          <Flex right>
            <Button
              type="submit"
              variant="primary"
              icon="paperAirplaneRight"
              loading={loading}
              disabled={!prompt.trim() || loading}>
              Send
            </Button>
          </Flex>
        </Flex>
      </Footer>
    </Container>
  );
};

AssistantPanel.propTypes = {
  messages: PropTypes.array.isRequired,
  prompt: PropTypes.string.isRequired,
  loading: PropTypes.bool.isRequired,
  onPromptChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired
};

export default AssistantPanel;
